export const BUSINESS = {
    name: "Lawn Busters",
    phone: "0481 831 282",
    phoneHref: "tel:+61481831282",
    email: "Lawnbusters21@gmail.com",
    city: "Adelaide, South Australia",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHOTOS = {
    hero: "/assets/photos/team.jpg",
    lawn: "/assets/photos/team.jpg",
    lawnTools: "/assets/photos/lawn-tools.jpg",
    gutter: "/assets/photos/gutter.jpg",
    gutterHand: "/assets/photos/gutter-hand.jpg",
    window: "/assets/photos/window.jpg",
    junk: "/assets/photos/real-a.jpg",
    teamGroup: "/assets/photos/team-group.jpg",
};

export const SERVICES = [
    {
        slug: "lawn-care",
        name: "Lawn Care",
        short: "Mowing, hedge trimming, edging, weed removal and garden care.",
        img: PHOTOS.lawn,
        real: true,
        path: "/lawn-care",
        testid: "service-card-lawn-care",
    },
    {
        slug: "gutter-window",
        name: "Gutter & Window Cleaning",
        short: "Professional gutter and window cleaning.",
        img: PHOTOS.window,
        real: true,
        path: "/gutter-window-cleaning",
        testid: "service-card-gutter-window",
    },
    {
        slug: "junk-removal",
        name: "Junk Removal",
        short: "Reliable removal of unwanted junk and general property waste.",
        img: PHOTOS.junk,
        real: true,
        path: "/junk-removal",
        testid: "service-card-junk-removal",
    },
];

export const BOOKING_SERVICES = ["Lawn Care", "Gutter Cleaning", "Window Cleaning", "Junk Removal"];

export const RESULTS = [
    {
        id: "hedge-trimming",
        title: "Hedge Trimming",
        before: "/assets/photos/hedge-before.jpg",
        after: "/assets/photos/hedge-after.jpg",
        blurb: "A wild, overgrown hedge squared off and trimmed back into a crisp, neat border.",
    },
    {
        id: "gutter-cleaning",
        title: "Gutter Cleaning",
        before: "/assets/photos/gutter-before.jpg",
        after: "/assets/photos/gutter-after.jpg",
        blurb: "A gutter packed with leaves and debris cleared right out and left flowing freely.",
    },
    {
        id: "weed-removal",
        title: "Weed Removal / Garden Cleanup",
        before: "/assets/photos/weeds-before.jpg",
        after: "/assets/photos/weeds-after.jpg",
        blurb: "Overgrown weeds and vegetation cleared, with the area left clean and tidy.",
    },
    {
        id: "paving-cleanup",
        title: "Garden / Paving Cleanup",
        before: "/assets/photos/paving-before.jpg",
        after: "/assets/photos/paving-after.jpg",
        blurb: "Weeds growing through the paving removed and the paving cleaned up.",
    },
    {
        id: "lawn-cleanup",
        title: "Overgrown Lawn Cleanup",
        before: "/assets/photos/lawn-before.jpg",
        after: "/assets/photos/lawn-after.jpg",
        blurb: "Overgrown lawn mowed and tidied, with the whole yard left neat and usable again.",
    },
];

export const SOCIALS = [
    { name: "Facebook", url: "https://www.facebook.com/share/1JV3v85DHX/", testid: "social-facebook-link" },
    { name: "Instagram", url: "https://www.instagram.com/lawnbusters.21/?hl=en", testid: "social-instagram-link" },
    { name: "YouTube", url: "https://youtube.com/@lawnbusters21?si=8VaMs8eCVvXnxjcV", testid: "social-youtube-link" },
    { name: "Find us on Google", url: "https://share.google/4SeqFAeGRq13rR53A", testid: "social-google-reviews-link" },
];

export const GOOGLE = {
    rating: "5.0",
    count: 28,
    url: "https://share.google/4SeqFAeGRq13rR53A",
};

export const REVIEWS = [
    {
        name: "Lachlan Moose",
        text: "Great service, quick response, amazing results and fair pricing, would go back.",
        testid: "review-card-lachlan",
    },
    {
        name: "TUC danimaxP",
        text: "Gunveer, Daniel and Ethen all do a amazing job around the house, the have been doing monthly maintenance all around the yard and always go beyond the standard. they've even done my gutters for free. I definitely recommend them",
        testid: "review-card-tuc",
    },
    {
        name: "Ameeran Ali",
        text: "Wonderful service! Particularly impressed with their efficiency and friendliness. 100% would recommend to friends!",
        testid: "review-card-ameeran",
    },
    {
        name: "Kasey Reardon",
        text: "The guys done a great job with my front, side and back yard. Cleared out lots of overgrown weeds and cleaned up the lawn. They'll definately get a call to come back again.",
        testid: "review-card-kasey",
    },
    {
        name: "Andrew Lawrence",
        text: "Fair price. Work completed on time. Highly recommend.",
        testid: "review-card-andrew",
    },
    {
        name: "Arjun M",
        text: "Great price. Amazing service! Very good service, really nice to talk to and most importantly, Lawn Busters really fulfilled their promise of transforming my lawn for the better!",
        testid: "review-card-arjun",
    },
];

export const TIME_OPTIONS = ["Morning (8am - 12pm)", "Afternoon (12pm - 5pm)", "Any time"];
